import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=83953b20&scoped=true&"
import script from "./TV.vue?vue&type=script&lang=ts&"
export * from "./TV.vue?vue&type=script&lang=ts&"
import style0 from "./TV.vue?vue&type=style&index=0&id=83953b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83953b20",
  null
  
)

export default component.exports